module.exports = __webpack_public_path__ + "media/transparent.30c8e7aa.png";